var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-broadcast" },
    [
      _c(
        "a-steps",
        {
          attrs: { current: _vm.currentStep - 1 },
          on: { change: _vm.handleStepChange },
        },
        [
          _c("a-step", { attrs: { title: _vm.$t("message.titleAndDesc") } }),
          _vm._v(" "),
          _c("a-step", {
            attrs: { title: _vm.$t("message.templateAndMailSelection") },
          }),
          _vm._v(" "),
          _c("a-step", { attrs: { title: _vm.$t("message.peopleToSend") } }),
          _vm._v(" "),
          _c("a-step", { attrs: { title: _vm.$t("message.submissionPlans") } }),
          _vm._v(" "),
          _c("a-step", { attrs: { title: _vm.$t("message.summary") } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "steps-content" }, [
        _vm.currentStep === 1
          ? _c(
              "div",
              [
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("message.broadcastTitle") } },
                  [
                    _c("a-input", {
                      model: {
                        value: _vm.broadcast.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.broadcast, "title", $$v)
                        },
                        expression: "broadcast.title",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("message.description") } },
                  [
                    _c("a-textarea", {
                      model: {
                        value: _vm.broadcast.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.broadcast, "description", $$v)
                        },
                        expression: "broadcast.description",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === 2
          ? _c("div", { staticClass: "template-selection" }, [
              _c(
                "div",
                { staticClass: "selection-panel" },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("message.sentByEmail") } },
                    [
                      _c(
                        "a-select",
                        {
                          model: {
                            value: _vm.broadcast.senderEmail,
                            callback: function ($$v) {
                              _vm.$set(_vm.broadcast, "senderEmail", $$v)
                            },
                            expression: "broadcast.senderEmail",
                          },
                        },
                        _vm._l(_vm.mails, function (email) {
                          return _c(
                            "a-select-option",
                            { key: email._id, attrs: { value: email._id } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(email.mail) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("message.emailTemplate") } },
                    [
                      _c(
                        "a-select",
                        {
                          model: {
                            value: _vm.broadcast.template,
                            callback: function ($$v) {
                              _vm.$set(_vm.broadcast, "template", $$v)
                            },
                            expression: "broadcast.template",
                          },
                        },
                        _vm._l(_vm.templates, function (temp) {
                          return _c(
                            "a-select-option",
                            { key: temp.key, attrs: { value: temp.key } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(temp.name) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.broadcast.template
                    ? _c(
                        "div",
                        _vm._l(_vm.getParams(), function (param) {
                          return _c(
                            "a-form-item",
                            { key: param, attrs: { label: param } },
                            [
                              _c(
                                "a-select",
                                {
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleParamChange(
                                        param,
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.selectedParam[param],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.selectedParam, param, $$v)
                                    },
                                    expression: "selectedParam[param]",
                                  },
                                },
                                _vm._l(_vm.parameterOptions, function (option) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: option.value,
                                      attrs: { value: option.value },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(option.label) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _vm.selectedParam[param] === "custom"
                                ? _c("a-input", {
                                    attrs: { value: _vm.getParamVal(param) },
                                    on: {
                                      input: function ($event) {
                                        return _vm.updateParam(
                                          param,
                                          "custom",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "preview-panel" },
                [
                  _vm.broadcast.template
                    ? _c("EmailTemplateEditor", {
                        key: _vm.broadcast.template,
                        attrs: {
                          template: _vm.selectedTemplate,
                          "preview-mode": "",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === 3
          ? _c(
              "div",
              {
                staticClass: "members-content",
                staticStyle: { display: "flex", gap: "10px" },
              },
              [
                _c("a-alert", {
                  attrs: {
                    message: _vm.$t("message.onlyPeopleWithEmail"),
                    type: "info",
                  },
                }),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    model: {
                      value: _vm.broadcast.customerGroup,
                      callback: function ($$v) {
                        _vm.$set(_vm.broadcast, "customerGroup", $$v)
                      },
                      expression: "broadcast.customerGroup",
                    },
                  },
                  _vm._l(_vm.customerGroups, function (customerGroup) {
                    return _c(
                      "a-select-option",
                      {
                        key: customerGroup._id,
                        attrs: { value: customerGroup._id },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(customerGroup.name) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "members-content-list" },
                  [
                    _c("div", { staticClass: "members-content-title" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("wp.customerGroups")) +
                          " (" +
                          _vm._s(_vm.totalContacts) +
                          ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.broadcast.customerGroup
                      ? _c("supsis-table", {
                          attrs: {
                            columns: _vm.getColumns(),
                            rows: _vm.contacts,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === 4
          ? _c(
              "div",
              { staticClass: "schedule-step" },
              [
                _c(
                  "supsis-button",
                  {
                    attrs: {
                      primary: _vm.isNowSelected,
                      ghost: !_vm.isNowSelected,
                      classNames: "schedule-button",
                    },
                    on: { click: _vm.scheduleNow },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.sendNow")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "supsis-button",
                  {
                    attrs: {
                      primary: _vm.isScheduleSelected,
                      ghost: !_vm.isScheduleSelected,
                      classNames: "schedule-button",
                    },
                    on: { click: _vm.scheduleLater },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.plan")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.isScheduleSelected
                  ? _c(
                      "div",
                      [
                        _c("a-date-picker", {
                          attrs: { "show-time": "" },
                          model: {
                            value: _vm.scheduleDate,
                            callback: function ($$v) {
                              _vm.scheduleDate = $$v
                            },
                            expression: "scheduleDate",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === 5
          ? _c("div", { staticClass: "summary-step" }, [
              _c("div", { staticClass: "summary-boxes" }, [
                _c("div", { staticClass: "summary-box" }, [
                  _c("div", { staticClass: "box-title" }, [
                    _vm._v(_vm._s(_vm.$t("message.title"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-value" }, [
                    _vm._v(_vm._s(_vm.broadcast.title)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "summary-box" }, [
                  _c("div", { staticClass: "box-title" }, [
                    _vm._v(_vm._s(_vm.$t("message.senderEmail"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-value" }, [
                    _vm._v(_vm._s(_vm.getSenderEmail)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "summary-box" }, [
                  _c("div", { staticClass: "box-title" }, [
                    _vm._v(_vm._s(_vm.$t("message.totalBuyer"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-value" }, [
                    _vm._v(
                      _vm._s(_vm.totalContacts) +
                        " " +
                        _vm._s(_vm.$t("message.person"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "summary-box" }, [
                  _c("div", { staticClass: "box-title" }, [
                    _vm._v(_vm._s(_vm.$t("message.estimatedDuration"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-value" }, [
                    _vm._v(_vm._s(_vm.estimatedDuration)),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === 6
          ? _c("div", { staticClass: "final-step" }, [
              _c("p", [
                _vm._v(_vm._s(_vm.$t("message.shippingIsNowComplete"))),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "steps-action" }, [
        _c(
          "div",
          { staticClass: "button-group" },
          [
            _vm.currentStep === 1
              ? _c(
                  "supsis-button",
                  { attrs: { small: "" }, on: { click: _vm.gotoList } },
                  [_vm._v(" " + _vm._s(_vm.$t("message.back")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentStep > 1
              ? _c(
                  "supsis-button",
                  { attrs: { small: "" }, on: { click: _vm.prev } },
                  [_vm._v(" " + _vm._s(_vm.$t("message.back")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentStep < 5
              ? _c(
                  "supsis-button",
                  {
                    attrs: { primary: "", small: "" },
                    on: { click: _vm.next },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("message.continue")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentStep === 5
              ? _c(
                  "supsis-button",
                  {
                    attrs: { primary: "", small: "" },
                    on: { click: _vm.submitBroadcast },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("message.send")))]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }